"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApMenuContext = void 0;
var lodash_1 = require("lodash");
var react_1 = require("react");
exports.ApMenuContext = react_1.createContext({
    closeAll: lodash_1.noop,
    closeMenu: lodash_1.noop,
    small: false,
    depth: -1,
    isOpen: false,
});
exports.default = exports.ApMenuContext;
//# sourceMappingURL=context.js.map